<div class="wrapper">
  <span class="c-dropdown toggle">
    <button
      (click)="toggleDropdown()"
      data-automation-e2e-selector="seriesSelectBox"
      #filterDropdown
      [cupcakeDropdownTrigger]="{
        expandAreaWidth: 200,
        expandAreaAlign: 'right',
        trigger: 'manual'
      }"
      class="seriesButton"
    >
      <span class="left">
        Series
        <span
          *ngFor="let code of selectedSeriesCodes | async; let l = last"
          [textContent]="getSelectedSeriesCode(code, l)"
        >
        </span
        >&nbsp;
      </span>
      <span class="right">
        <i aria-hidden="true" class="fa fa-angle-down"></i>
      </span>
    </button>
    <ul
      role="menu"
      class="c-dropdown-list c-dropdown-list-below"
      data-automation-e2e-selector="seriesPopup"
    >
      <li
        role="menuitem"
        (click)="filter.next(series)"
        *ngFor="let series of selectableSeries | async"
        class="seriesList"
      >
        <div class="c-checkbox">
          <input
            type="checkbox"
            [id]="series.id"
            [checked]="series.selected"
            (click)="$event.stopPropagation(); filter.next(series)"
          />
          <label
            [for]="series.id"
            (click)="$event.stopPropagation(); $event.preventDefault(); filter.next(series)"
          >Series {{ series.code }}</label>
        </div>
      </li>
    </ul>
  </span>
</div>
